/* eslint-disable no-throw-literal */
import { clientTwo } from '../../Components/Client';

let session = undefined;

const validatedSession = () => {
  const now = new Date().getTime();

  if (session.expiry < now) {
    session = undefined;
    localStorage.removeItem('session');
    return undefined;
  }

  return session;
};

export const getSession = () => {
  // MINIMAL FIX: Always check localStorage first, even if session exists in memory
  let json = localStorage.getItem('session');

  if (!json) {
    session = undefined; // Clear memory cache if localStorage is empty
    return undefined;
  }

  // MINIMAL FIX: Parse and update the session from localStorage
  const storedSession = JSON.parse(json);

  // If stored session is different from memory session, update it
  if (!session || session.token !== storedSession.token) {
    session = storedSession;
  }

  return validatedSession();
};

export const setSession = (newSession) => {
  if (!!newSession) {
    session = newSession;
    localStorage.setItem('session', JSON.stringify(newSession));
  } else {
    localStorage.removeItem('session');
  }
};

const getTwo = async (uri) => {
  if (!getSession()) throw 'Not logged in';

  const response = await clientTwo.get(uri, {
    headers: {
      Authorization: `Bearer ${session.token}`,
    },
  });

  return response;
};

const postTwo = async (uri, payload) => {
  if (!getSession()) throw 'Not logged in';

  const response = await clientTwo.post(uri, payload, {
    headers: {
      Authorization: `Bearer ${session.token}`,
    },
  });

  return response;
};

const getPublicTwo = async (uri) => {
  const response = await clientTwo.get(uri);

  return response;
};

const emptyPageResult = () => ({
  items: [],
  page: 0,
  pageSize: 10,
  length: 0,
});

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getSession,
  setSession,
  emptyPageResult,
  getPublicTwo,
  getTwo,
  postTwo,
};
